import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import i18next from 'i18next';

import Alert from '@/common/components/Alert';

const { UI } = Mobi2Go;

let is_alert_open = false;
let previous_alert_options;
let auto_close_timeout;

Mobi2Go.onReady(() => {
    const alert_view = document.createElement('div');
    alert_view.classList.add('m2g-external-alert');
    alert_view.classList.add('m2g-external-alert--closed');

    const modals_container = document.querySelector('[data-external-modals]');
    modals_container.appendChild(alert_view);

    const openAlert = () => {
        alert_view.classList.remove('m2g-external-alert--closed');
        alert_view.classList.add('m2g-external-alert--open');
        alert_view.scrollTop = 0;

        is_alert_open = true;

        UI.trigger('alertOpen');
    };

    const closeAlert = () => {
        alert_view.classList.remove('m2g-external-alert--open');
        alert_view.classList.add('m2g-external-alert--closed');

        if (previous_alert_options && previous_alert_options.onClose) {
            // Legacy safe guard against infinite loop.
            // Didn't dig into more details as to why this was needed.
            const { onClose } = previous_alert_options;
            previous_alert_options.onClose = null;
            onClose();
        }

        is_alert_open = false;
        previous_alert_options = null;
        clearTimeout(auto_close_timeout);
        auto_close_timeout = null;

        UI.trigger('alertClosed');
    };

    UI.closeCenteredAlert = () => {
        if (is_alert_open) {
            closeAlert();
        }
    };

    UI.centeredAlert = (
        alert_options = {
            id: null,
            title: i18next.t('common:attention'),
            body: undefined,
            close_button: true,
            footer: true,
            temp: false,
            show_progress_bar: false,
            primary_button: i18next.t('common:ok'),
            secondary_button: undefined,
            temp_duration: 5600,
            onPrimaryButtonClick: undefined,
            onSecondaryButtonClick: undefined,
            onClose: undefined,
        }
    ) => {
        // This is the single way to close all alerts
        // UI.alert and UI.centeredAlert
        UI.closeAlert();

        const temp_duration = alert_options.temp_duration || 5600;

        ReactDOM.render(
            <Alert
                {...alert_options}
                temp_duration={temp_duration}
                onClose={closeAlert}
                onPrimaryButtonClick={() => {
                    closeAlert();
                    if (_.isFunction(alert_options.onPrimaryButtonClick)) {
                        alert_options.onPrimaryButtonClick();
                    }
                }}
                onSecondaryButtonClick={() => {
                    closeAlert();
                    if (_.isFunction(alert_options.onSecondaryButtonClick)) {
                        alert_options.onSecondaryButtonClick();
                    }
                }}
            />,
            alert_view
        );

        openAlert();

        if (alert_options.temp && !Mobi2Go.app.disable_animation) {
            auto_close_timeout = setTimeout(closeAlert, temp_duration);
        }

        previous_alert_options = alert_options;
    };

    UI.bind({
        modalOpen: closeAlert,
        closeAlert,
        pageLeave: () => {
            if (UI.page && !UI.page.isFrozen()) {
                closeAlert();
            }
        },
    });
});
